export const LINE_SHARE_URL = 'https://social-plugins.line.me/lineit/share'
export const FACEBOOK_SHARE_URL = 'https://www.facebook.com/dialog/share'
export const FACEBOOK_APP_ID = '2793482247419590'
export const TWITTER_SHARE_URL = 'https://twitter.com/intent/tweet'
export const TWITTER_SOCIAL_SHARE_MESSAGE = '#ラクスルアパレル・ユニフォーム'
export const TWITTER_SHARE_MESSAGE = '#ラクスルアパレル・ユニフォーム で作りました！'
export const TWITTER_HASHTAGS = ['ラクスル', 'アパレル・ユニフォーム']
